__turbopack_context__.v({
  "backPill": "ParagraphDarkHeroBack-module__4LV0HW__backPill",
  "backPillIcon": "ParagraphDarkHeroBack-module__4LV0HW__backPillIcon",
  "badges": "ParagraphDarkHeroBack-module__4LV0HW__badges",
  "benefit": "ParagraphDarkHeroBack-module__4LV0HW__benefit",
  "benefitCheck": "ParagraphDarkHeroBack-module__4LV0HW__benefitCheck",
  "benefits": "ParagraphDarkHeroBack-module__4LV0HW__benefits",
  "categoryPill": "ParagraphDarkHeroBack-module__4LV0HW__categoryPill",
  "inner": "ParagraphDarkHeroBack-module__4LV0HW__inner",
  "lead": "ParagraphDarkHeroBack-module__4LV0HW__lead",
  "section": "ParagraphDarkHeroBack-module__4LV0HW__section",
  "title": "ParagraphDarkHeroBack-module__4LV0HW__title",
});
